import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { CreditMovementView } from "./CreditMovementView";
import { CreditMovementViewStore } from "../../store/CreditMovementViewStore";
import { useStore } from "../../../../hooks";

export const CreditMovementViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/creditMovement/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CreditMovementViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <CreditMovementView creditMovementViewStore={store} />
      </PageLayout>
    </div>
  );
});
